import React from "react";

import Blocks from "components/form/Blocks";

import usePageApi from "hooks/api/private/usePageApi";

function PageBlocksForm({ pageId }: { pageId: string }) {
    const { getOnePage } = usePageApi();

    const [blockGroupId, setBlockGroupId] = React.useState<string | null>(null);

    React.useEffect(() => {
        const [apiCall, abortController] = getOnePage({ id: pageId });

        apiCall.then((page) => setBlockGroupId(page.block_group_id));

        return () => abortController.abort();
    }, [getOnePage, pageId]);

    return <>{blockGroupId && <Blocks blockGroupId={blockGroupId} />}</>;
}

export default PageBlocksForm;
